// Gestão TFX no celular: põe o nome da coluna em cada célula (data-label) para as tabelas virarem cartões
// no celular (mobile.css). Só lê o cabeçalho das tabelas; não mexe em dados nem em eventos.
const MIN_COLUNAS = 4;

function rotular() {
  document.querySelectorAll('table').forEach((t) => {
    const cab = t.tHead?.rows?.[0] || (t.rows?.[0] && [...t.rows[0].cells].every((c) => c.tagName === 'TH') ? t.rows[0] : null);
    if (!cab || cab.cells.length < MIN_COLUNAS) return;
    // nome de cada coluna, contando colunas mescladas
    const nomes = [];
    for (const th of cab.cells) { const n = th.innerText.replace(/\s+/g, ' ').trim(); for (let k = 0; k < (th.colSpan || 1); k++) nomes.push(n); }
    if (!t.classList.contains('tfx-cards')) t.classList.add('tfx-cards');
    if (!t.tHead && !cab.classList.contains('tfx-cab')) cab.classList.add('tfx-cab');
    for (const tb of t.tBodies) {
      for (const r of tb.rows) {
        if (r === cab) continue;
        let i = 0;
        for (const c of r.cells) {
          const n = (c.colSpan || 1) > 1 ? '' : nomes[i] || '';
          if (c.getAttribute('data-label') !== n) c.setAttribute('data-label', n);
          i += c.colSpan || 1;
        }
      }
    }
  });
}

let agendado = null;
function agendar() { if (agendado) return; agendado = setTimeout(() => { agendado = null; try { rotular(); } catch (e) { /* nunca atrapalha o app */ } }, 120); }

if (typeof window !== 'undefined' && typeof MutationObserver !== 'undefined') {
  const iniciar = () => { agendar(); new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
}
